import React, { useEffect, useState } from "react";
import "./App.css";
import Appbar from "./components/Appbar/Appbar";
import Leaderboard from "./components/CoinsTable/Leaderboard";
import axios from "./axios";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import CoinPage from "./components/CoinPage/CoinPage";
import ExchangeBoard from "./components/ExchangeBoard/ExchangeBoard";
import ExchangeBoardSingleMarket from "./components/ExchangeBoardSingleMarket/ExchangeBoardSingleMarket";

function App() {
  const [currency, setCurrencies] = useState([]);

  useEffect(() => {
    axios.get("/rates").then((res) => {
      setCurrencies(res.data.data);
    });
  }, []);

  return (
    <div className="app">
      <Router>
        <Appbar currency={currency} />

        <Switch>
          <Route exact path="/">
            <Leaderboard />
          </Route>

          <Route path="/coins/:coinid">
            <CoinPage />
          </Route>

          <Route exact path="/exchanges/">
            <ExchangeBoard />
          </Route>
          <Route path="/exchanges/:exchangeId">
            <ExchangeBoardSingleMarket />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
